import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  presets: {
    size: {
      width: 103,
      height: 103
    }
  },
  showLabel: true
} satisfies Partial<CheckoutConfig['orderItem']>
